<template>
  <div class="pg-checkbox-group">
    <PgCheckbox
      v-for="source in sources"
      :key="source.code"
      :value="mapValue[source.code]"
      :style="CBstyle"
      :text="source.name"
      @change="(v, e) => change(v, source, e)"
    >
    </PgCheckbox>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import { ref } from 'vue'
import { PgCheckbox } from '../../checkbox/index'
import { useCheckboxGroup } from '../hooks/index'

const emit = defineEmits(['input'])

const data = ref([]) // 已选中

const props = defineProps({
  /**
   * 当前已选中
   * [
   *  {
   *    "name": "温度报警",
   *    "code": "temperature"
   *  }
   * ]
   */
  value: {
    type: Array,
    default() {
      return [
        {
          name: '湿度报警',
          code: 'humidity',
        },
      ]
    },
  },
  /**
   * 数据源
   * [
   *  {
   *    "name": "温度报警",
   *    "code": "temperature",
   *    "style": {
   *      width:'20%'
   *     },
   *  }
   * ]
   */
  sources: {
    type: Array,
    default() {
      return []
    },
  },
  // 单选框样式
  CBstyle: {
    type: Object,
    default() {
      return {}
    },
  },
})

const { init, mapValue, change } = useCheckboxGroup({ data, props, emit })
init()
</script>

<style lang="scss" scoped>
@import '../style/checkbox-group.scss';
</style>
